import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import moment from 'moment';
import { dateTimeFuture } from './validator';

@Directive({
  selector: '[dateTimeFuture]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DateTimeFutureDirective,
      multi: true
    }
  ]
})
export class DateTimeFutureDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const validationError = dateTimeFuture()(control);

    if (validationError && validationError.dateTimeFuture) {
      return { dateTimeFuture: true };
    }

    return null;
  }
}
